import React from "react";
import BenefitGlassCard from "../../components/PageSection/BenefitCard";

type BenefitItem = {
  title: string;
  description: string;
  icon: string;
};

type BenefitsGridSectionProps = {
  title: string;
  benefits: BenefitItem[];
};

const BenefitsGridSection: React.FC<BenefitsGridSectionProps> = ({
  title,
  benefits,
}) => {
  return (
    <section className="pt-80 pb-80">
      <div className="container">
        {/* TITLE */}
        <h2 className="xb-section-title text-center wow fadeInUp">
          {title}
        </h2>

        {/* GRID */}
        <div className="row mt-50">
          {benefits.map((benefit, i) => (
            <div
              key={i}
              className="col-lg-6 col-md-6 mb-30"
            >
              <BenefitGlassCard {...benefit} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsGridSection;
